import React from 'react';
import styled from 'styled-components';
import { BackgroundCheck } from '@indigo-ag/schema';
import { Dictionary } from 'lodash';
import { getTranslatedRole } from 'features/brazil-grower/pages/ContactDetailsPage/utils';
import { ContactBackgroundCheck } from '../../components/BackgroundCheck/ContactBackgroundCheck';
import { LargeTitle, palettes } from '@indigo-ag/component-module';
import i18next from 'i18next';

const CardContainer = styled.div`
  > div {
    margin-bottom: 16px;
  }
`;

interface BackgroundCheckListProps {
  contactRoles: Array<{
    contact: {
      name: string;
      taxIdentifier: string;
    };
    role: string;
    id: string;
  }>;
  backgroundChecksByTin: Dictionary<BackgroundCheck>;
}

export const BackgroundCheckSection: React.FC<BackgroundCheckListProps> = ({ contactRoles, backgroundChecksByTin }) => {
  return (
    <CardContainer>
      <LargeTitle style={{ marginBottom: '16px', color: palettes.brand.blue.base }}>
        {i18next.t('preAnalysisBackgroundCheck')}
      </LargeTitle>
      {contactRoles.map(({ contact: { name, taxIdentifier }, role, id: contactRoleId }) => {
        const backgroundCheck = taxIdentifier ? backgroundChecksByTin[taxIdentifier] : undefined;
        const title = `${name} - ${getTranslatedRole(role)}`;
        return (
          <ContactBackgroundCheck key={`${contactRoleId}-${role}-bc`} backgroundCheck={backgroundCheck} title={title} />
        );
      })}
    </CardContainer>
  );
};
